import { NavLink } from 'react-router-dom';
import { useState, useRef, useEffect } from 'react';
import { motion, AnimatePresence } from "framer-motion";

import '../Styles/Navigation.css';

import NavItem from './NavItem';

import Button from './Button';
import ArrowRight from './icons/ArrowRight';


function MobileNav() {
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null); 


  useEffect(() => {
    function handleClickOutside(e) {
      if (open && menuRef.current && !menuRef.current.contains(e.target)) {
        setOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open]);

  return (
    <div ref={menuRef} className="w-full fixed z-10 py-1 px-2">
      <div className="flex justify-between items-center rounded-image py-3 px-4 bg-lightgrey backdrop-blur-md shadow-md">
        
        <NavLink to={`/`}>
          <div className="logo flex flex-col items-center align-middle pl-2">
            <h1 className='font-heading font-medium text-2xl text-dark-900'>LV</h1>
          </div>
        </NavLink>

        <div 
          className="flex flex-row items-center gap-1 cursor-pointer" 
          onClick={() => setOpen(!open)}>
          <h3 className="font-body font-medium text-lg text-dark-900">Menu</h3>
          <motion.div
            animate={{ rotate: open ? 180 : 0 }}
            transition={{ duration: 0.2 }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="20" 
              viewBox="0 0 24 24" fill="none" stroke="#121212" strokeWidth="2" 
              strokeLinecap="round" strokeLinejoin="round"><path stroke="none" d="M0 0h24v24H0z" /><path d="M12 5l0 14" /><path d="M16 15l-4 4" /><path d="M8 15l4 4" /></svg>
          </motion.div>
        </div>       
      </div>

      <AnimatePresence initial={false}>
        {open && (
          <motion.div
            key="content"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.25, ease: "easeInOut" }}
            className="overflow-hidden mt-2"
          >
            <div className="flex flex-row justify-end overflow-x-hidden">
              <div className='flex flex-col items-start py-4 px-4 rounded-image text-left bg-lightgrey backdrop-blur-md shadow-sm gap-8'>
                <div className='flex flex-col gap-4 items-start w-full'>
  
                  <NavLink to={`/`} onClick={() => setOpen(false)}>
                    <NavItem>Home</NavItem>
                  </NavLink>

                  <NavLink to={`/Allprojects`} onClick={() => setOpen(false)}>
                    <NavItem>Projects</NavItem>
                  </NavLink>

                  <NavLink to={`/About`} onClick={() => setOpen(false)}>
                    <NavItem>About me</NavItem>
                  </NavLink>

                </div>

                <a href='mailto:lisanneverbeet@outlook.com'>
                  <Button icon={ArrowRight} iconPosition='right' variant='outline'>
                    Contact
                  </Button>
                </a> 
              </div>  

            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default MobileNav;